<template>
  <div class="organ-container">
    <organ-tree class="tree" :setOrganDetail="setOrganDetail" />
    <organ-detail class="detail" :organDetail="organDetail" v-if="organDetail.type === 3" />
    <organ-detail-company class="detail" :organDetail="organDetail" v-if="organDetail.type === 1" />
    <organ-detail-depart class="detail" :organDetail="organDetail" v-if="organDetail.type === 2" />
    <div class="background" v-if="organDetail.type === 0"></div>
    <Agreement ref="agreement" />
  </div>
</template>

<script>

import OrganTree from './OrganTree'
import OrganDetail from './OrganDetail'
import OrganDetailCompany from './OrganDetailCompany'
import OrganDetailDepart from './OrganDetailDepart'
import { createNamespacedHelpers } from 'vuex'
import Agreement from '@/components/business/Agreement'
const { mapState } = createNamespacedHelpers('collaborator')
export default {
  name: 'index',
  data(){
    return {
      // type: 1公司，2中间层，3人员
      organDetail: {
        type: 0,
        companyName: '',
        companyDesc: '',
        companyAddr: '',
        middleName: '',
        userName: '',
        count: 0,
      }
    }
  },
  computed: {
    ...mapState(['detailUserInfo'])
  },
  watch: {
    // 数据到目的地，中间需要获取，做监听处理
    detailUserInfo: {
      handler () {
        this.organDetail = {
          type: 3,
          companyName: '',
          companyDesc: '',
          companyAddr: '',
          middleName: '',
          userName: '',
          count: 0,
        }
      },
      deep: true
    }
  },
  activated() {
    this.$refs.agreement.getAgreementStatusHandle()
  },
  methods: {
    setOrganDetail(val){
      this.organDetail = { ...val }
    }
  },
  components: {
    OrganTree,
    OrganDetail,
    OrganDetailCompany,
    OrganDetailDepart,
    Agreement
  },
}
</script>

<style scoped lang="less">
.organ-container {
  height: 100%;
  display: flex;
  flex-direction: row;

  .tree {
    flex: 0 0 344px;
  }

  .detail {
    flex: 1;
  }

  .background{
    position: relative;
    background: #F7F8FA;
    box-shadow: 5px 0 10px 0 rgba(151, 171, 199, 0.06);
    flex: 1;
  }
}
</style>
